import axios from 'axios';
import { API_BASE_URL } from '../config';

const headers = (token) => ({ Authorization: `Bearer ${token}` });

/**
 * Obtiene el estado de cierre mensual de todos los meses de un año.
 * Reutiliza el endpoint existente de cierre mensual.
 * @returns {Promise<Object>} Mapa { [mes]: cerrado } donde mes es 1-12
 */
const getEstadoCierre = async (idCompany, anio, token) => {
  const response = await axios.get(`${API_BASE_URL}/api/cierre-mensual`, {
    params: { company: idCompany, anio },
    headers: headers(token),
  });
  const mapa = {};
  response.data.forEach((r) => { mapa[r.mes] = r.cerrado; });
  return mapa;
};

/**
 * Dispara la descarga del Libro de Caja en Excel para un período cerrado.
 * Abre el archivo directamente en el navegador como descarga.
 */
const descargarExcelLibroCaja = (idCompany, mes, anio, token) => {
  return _descargarArchivo(
    `${API_BASE_URL}/api/libro-caja/excel`,
    { id_company: idCompany, mes, anio },
    token,
    `libro-caja-${anio}-${String(mes).padStart(2, '0')}.xlsx`
  );
};

/**
 * Dispara la descarga del Libro de Caja en PDF foliado para un período cerrado.
 */
const descargarPdfLibroCaja = (idCompany, mes, anio, token) => {
  return _descargarArchivo(
    `${API_BASE_URL}/api/libro-caja/pdf`,
    { id_company: idCompany, mes, anio },
    token,
    `libro-caja-${anio}-${String(mes).padStart(2, '0')}.pdf`
  );
};

/**
 * Dispara la descarga del Libro de Ingresos y Egresos en Excel para un período cerrado.
 */
const descargarExcelLibroIngresosEgresos = (idCompany, mes, anio, token) => {
  return _descargarArchivo(
    `${API_BASE_URL}/api/libro-ingresos-egresos/excel`,
    { id_company: idCompany, mes, anio },
    token,
    `libro-ingresos-egresos-${anio}-${String(mes).padStart(2, '0')}.xlsx`
  );
};

/**
 * Dispara la descarga del Libro de Ingresos y Egresos en PDF foliado para un período cerrado.
 */
const descargarPdfLibroIngresosEgresos = (idCompany, mes, anio, token) => {
  return _descargarArchivo(
    `${API_BASE_URL}/api/libro-ingresos-egresos/pdf`,
    { id_company: idCompany, mes, anio },
    token,
    `libro-ingresos-egresos-${anio}-${String(mes).padStart(2, '0')}.pdf`
  );
};

/**
 * Helper interno: realiza GET con token, recibe blob y dispara descarga en el navegador.
 */
const _descargarArchivo = async (url, params, token, nombreArchivo) => {
  const response = await axios.get(url, {
    params,
    headers: headers(token),
    responseType: 'blob',
  });
  const blob = new Blob([response.data]);
  const href = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = href;
  link.download = nombreArchivo;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(href);
};

const librosContablesService = {
  getEstadoCierre,
  descargarExcelLibroCaja,
  descargarPdfLibroCaja,
  descargarExcelLibroIngresosEgresos,
  descargarPdfLibroIngresosEgresos,
};

export default librosContablesService;
